import {
    getData, postData, putData, deleteData
} from "adminApi/apiClient";

const API_URL = `duty-roster`;

// --- ROSTER API ---
export const GetAllRoster = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search,
        });

        const result = await getData(`${API_URL}/list?${queryParams}`, {}, {}, signal);
        return {
            success: true,
            ...result,
        };
    } catch (error) {
        console.error("Get Roster List API error:", error);
        return {
            success: false,
            ...error,
        };
    }
};

export const CreateRoster = async ({ data }) => {
    try {
        const result = await postData(`${API_URL}/add`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Create Roster API error:", error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data?.error : error.message,
                status: error.status,
            },
        };
    }
};

export const UpdateRoster = async ({ id, data }) => {
    try {
        const result = await putData(`${API_URL}/update/${id}`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Update Roster API error:", error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data?.error : error.message,
                status: error.status,
            },
        };
    }
};

export const GetRosterById = async (id) => {
    try {
        const result = await getData(`${API_URL}/${id}`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Get Roster by ID API error:", error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

export const DeleteRoster = async ({ id }) => {
    try {
        const result = await deleteData(`${API_URL}/delete/${id}`);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Delete Roster API error:", error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};

// get pool type
export const getAllshift = async () => {
    try {
        const result = await getData(`${API_URL}/get/all/shift`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error(`Get Pool Type API error:`, error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};